function getCurrentLang() {
  const urlArr = location.pathname.split('/')
  if (urlArr[1]) {
    const lang = LANGUAGES?.find(l => l?.value === urlArr[1])
    return lang ? lang.value : 'en'
  }

  return 'en'
}

const ALL_LANGUAGES_LIST = [
  { name: 'English', value: 'en', flag: '' },
  { name: 'Kazakh', value: 'kz', flag: '' },
  { name: 'Georgian', value: 'ge', flag: '' },
  { name: 'Russian', value: 'rus', flag: '' },
  { name: 'Ukrainian', value: 'ua', flag: '' },
  { name: 'Lithuanian', value: 'lt', flag: '' },
  { name: 'Latvian', value: 'lv', flag: '' },
  { name: 'Polish', value: 'pl', flag: '' },
  { name: 'In_context', value: 'aa', flag: '' },
]

export const LANGUAGES = []

const pushToLangListHandler = value => {
  const detectedLang = ALL_LANGUAGES_LIST?.find(lang => lang.value === value)
  if (detectedLang) {
    LANGUAGES?.push(detectedLang)
  }
}

if (process.env.AVAILABLE_LANGUAGES) {
  const langList = process.env.AVAILABLE_LANGUAGES?.split(',')
  if (langList?.length > 0) {
    langList?.forEach(lang => pushToLangListHandler(lang))
  } else {
    pushToLangListHandler('en')
  }
}

export const currentLang = getCurrentLang()
